export default {
    name: 'ad',
    tel: 'Telefon',
    save: 'yadda saxla',
    confirm: 'təsdiq edin',
    cancel: 'Ləğv et',
    delete: 'silin',
    complete: 'Bitir',
    loading: 'yüklənir...',
    telEmpty: 'Zəhmət olmasa telefon nömrəsini doldurun',
    nameEmpty: 'Zəhmət olmasa adınızı daxil edin',
    nameInvalid: 'Lütfən, düzgün ad daxil edin',
    confirmDelete: 'Silmək istədiyinizə əminsiniz',
    telInvalid: 'Zəhmət olmasa düzgün telefon nömrəsini daxil edin',
    vanCalendar: {
        end: 'Bitir',
        start: 'başlamaq',
        title: 'başlıq',
        confirm: 'təsdiq edin',
        startEnd: 'başla son',
        weekdays: ['gün', 'bir', 'iki', 'üç', 'dörd', 'beş', 'altı'],
    },
    vanCascader: {
        select: 'zəhmət olmasa seçin',
    },
    vanContactCard: {
        addText: 'Kontaktlar əlavə edin',
    },
    vanContactList: {
        addText: 'yeni əlaqə',
    },
    vanPagination: {
        prev: 'Əvvəlki səhifə',
        next: 'Növbəti səhifə',
    },
    vanPullRefresh: {
        pulling: 'Yeniləmək üçün aşağı çəkin...',
        loosing: 'Yeniləməni buraxın...',
    },
    vanSubmitBar: {
        label: 'hamısı:',
    },
    vanCoupon: {
        unlimited: 'İstifadə məhdudiyyəti yoxdur',
    },
    vanCouponCell: {
        title: 'kupon',
        tips: 'Mövcud deyil',
    },
    vanCouponList: {
        empty: 'kupon yoxdur',
        exchange: 'mübadilə',
        close: 'kupon yoxdur',
        enable: 'istifadəyə yararlı',
        disabled: 'Mövcud deyil',
        placeholder: 'Endirim kodunu daxil edin',
    },
    vanAddressEdit: {
        area: 'sahə',
        postal: 'Poçt kodu',
        areaEmpty: 'Region seçin',
        addressEmpty: 'Zəhmət olmasa ətraflı ünvanı doldurun',
        postalEmpty: 'Poçt kodunun formatı yanlışdır',
        defaultAddress: 'Defolt göndərmə ünvanı kimi təyin edin',
        telPlaceholder: 'Alıcının mobil telefon nömrəsi',
        namePlaceholder: 'Alıcı adı',
        areaPlaceholder: 'Vilayət/şəhər/rayon seçin',
    },
    vanAddressEditDetail: {
        label: 'ünvanı',
        placeholder: 'Küçə evinin nömrəsi, mərtəbə otağının nömrəsi və digər məlumatlar',
    },
    vanAddressList: {
        add: 'Ünvan əlavə edin',
    },
};
